import { Link } from "react-router-dom";

import withLayoutOptions from "../../components/withLayoutOptions/withLayoutOptions";

import useImgSet from "../../hooks/useImgSet";

import s from "./PageFather.module.scss";

function PageFather() {
  const getImgSet = useImgSet();

  const description = getImgSet("description__p21", "png", s.description);
  const item01 = getImgSet("item__01__p21", "png");
  const item02 = getImgSet("item__02__p21", "png");
  const item03 = getImgSet("item__03__p21", "png");
  const item04 = getImgSet("item__04__p21", "png", [s.item, s.item__04]);
  const pointer = getImgSet("pointer__father", "png", s.pointer);

  const back = getImgSet("back__p21", "png");
  const imgA = getImgSet("bear__01", "png", s.img__a);
  const imgB = getImgSet("img__p21", "png", s.img__b);
  const action = getImgSet("action__01__p21", "png");
  const quizBtn = getImgSet("button__quiz", "png");

  return (
    <div className={s.root}>
      {pointer}
      <div className={s.aside_left}>
        <Link to="/" className={s.back}>
          {back}
        </Link>
        {imgA}
      </div>
      <div className={s.inner}>
        {description}
        <Link to="c" className={s.item}>
          {item01}
        </Link>
        <Link to="c" className={s.item}>
          {item02}
        </Link>
        <Link to="d" className={s.item}>
          {item03}
        </Link>
        {item04}
      </div>
      <div className={s.aside_right}>
        {imgB}
        <Link to="a" className={s.action}>
          {action}
        </Link>
        <Link to="/father/quiz" className={s.button__quiz}>
          {quizBtn}
        </Link>
      </div>
    </div>
  );
}

export default withLayoutOptions(PageFather);
